import { helper } from '@/utils'
import Logo from '../Logo/Logo.vue'
import Company from '../Company/Company.vue'

export default {
  name: 'Welcome',
  components: { Company, Logo },
  computed: {
    isMobile: helper.isMobile
  },
  data () {
    return {
      appleStore: '',
      component: 'welcome',
      footer: {},
      googlePlay: '',
      primaryColor: '#00BAFF',
      title: '',
      url: '',
      welcomeBody: ''
    }
  },
  methods: {
    getData () {
      return this.getTheme()
        .then(theme => {
          this.footer = {
            companyAddress: theme.company_address,
            companyContact: theme.company_contact,
            companyName: theme.company_name,
            companyUrl: theme.company_url
          }
          this.primaryColor = theme.primary_color
          this.googlePlay = theme.google_play
          this.appleStore = theme.apple_store
          this.url = theme.app_url_scheme + location.host
          this.title = this.getReplacedString('welcome_web_headline', theme)
          this.welcomeBody = this.getReplacedString('welcome_web_body', theme)
        })
        .catch((error) => helper.showErrorMessage(this, this.component, error))
    },
    getTheme () {
      return this.$api.getTheme()
        .then(({ body }) => body)
    },
    getReplacedString (key, theme) {
      return (theme[key] || '')
        .replace(/{{product_name}}/g, theme.product_name)
        .replace(/{{app_name}}/g, theme.app_name)
    }
  },
  mounted () {
    this.getData()
  }
}



// WEBPACK FOOTER //
// ./src/assets/pages/Welcome/Welcome.js